import EnlilAxiosRestAPI from "../../../../util/EnlilAxiosRestAPI";
import {V1AdminUserGroupMembershipIDOCToArray} from "../../../../util/Payload";
import EnterpriseComponent from "../../EnterpriseComponent";
import {SessionContext} from "../../../../util/SessionContext";


class AdminUserGroupMembershipEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, _) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        EnlilAxiosRestAPI({
            method: "GET",
            url: "t3/v1/admin_user_group_memberships",
            json: true,
            params: {
                "Limit": pageSize,
                "Offset": (page - 1) * pageSize,
                "Sort": this.getFormattedSortSpecification(),
                ...this.getSearchSpecification(),
            },
            headers: {
                "idoc-response": this.getIDOCResponse() ?? "v1.AdminUserGroupMembership-001",
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1AdminUserGroupMembershipIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPutIDOC = () => {
        let payload = {};

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.AdminUserGroupMembership-001";
        payload.ShifamedMessage.AdminUserGroupMembership = this.preparePUTPayload();

        return payload;
    };

    performUpdate() {
        let payload = this.enterpriseComponentPutIDOC();

        let options = {
            method: "PUT",
            url: "t3/v1/admin_user_group_memberships",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.AdminUserGroupMembership-001",
                "idoc-response": "v1.AdminUserGroupMembership-001",
            },
        };
        this.notifyUpdateStartListeners();
        EnlilAxiosRestAPI(options)
            .then(response => {
                this.updateEnterpriseComponentSuccess(V1AdminUserGroupMembershipIDOCToArray(response.data));
            })
            .catch(error => {
                this.updateEnterpriseComponentFailed(error);
            });
    };

    enterpriseComponentPostIDOC = () => {
        let payload = {};

        let sessionContext = new SessionContext();

        let adminUserGroupMembership = {};

        adminUserGroupMembership["USID"] = this.getAttributeValue("USID");
        adminUserGroupMembership["SourceUSID"] = sessionContext.getGeneralPurposeVariable();
        adminUserGroupMembership["SourceType"] = "Project Plan";
        adminUserGroupMembership["UserGroupUSID"] = this.getAttributeValue("UserGroupUSID")

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.AdminUserGroupMembership-001";
        payload.ShifamedMessage.AdminUserGroupMembership = adminUserGroupMembership;

        return payload;
    };

    performInsert() {
        let payload = this.enterpriseComponentPostIDOC();

        let options = {
            method: "POST",
            url: "t3/v1/admin_user_group_memberships",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.AdminUserGroupMembership-001",
                "idoc-response": "v1.AdminUserGroupMembership-002"
            },
        };
        this.notifyInsertStartListeners();
        EnlilAxiosRestAPI(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1AdminUserGroupMembershipIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };

    enterpriseComponentDeleteIDOC = () => {
        let payload = {};

        let adminUserGroupMembership = {};

        adminUserGroupMembership["USID"] = this.getAttributeValue("USID");

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.AdminUserGroupMembership-001";
        payload.ShifamedMessage.AdminUserGroupMembership = adminUserGroupMembership;

        return payload;
    };

    performDelete() {
        let payload = this.enterpriseComponentDeleteIDOC();

        let options = {
            method: "DELETE",
            url: "t3/v1/admin_user_group_memberships",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.AdminUserGroupMembership-001"
            },
        };
        this.notifyDeleteStartListeners();
        EnlilAxiosRestAPI(options)
            .then(() => {
                this.deleteEnterpriseComponentSuccess();
            })
            .catch(error => {
                this.deleteEnterpriseComponentFailed(error);
            });
    };
}

export default AdminUserGroupMembershipEnterpriseComponent;